export default "__VITE_ASSET__C0d3fNVZ__"